module.exports = require('next/app')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dist/pages/_app.js
// module id = ./node_modules/next/dist/pages/_app.js
// module chunks = 2